import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { useCustomTranslation } from 'hooks/useCustomTranslation'
import Hero from './Hero/Hero'
import About from './About/About'
import LatestNews from './LatestNews/LatestNews'
import Quotation1 from './Quotations/Quotation1/Quotation1'
import Quotation2 from './Quotations/Quotation2/Quotation2'
import Loader from 'components/Loader/Loader'

const Home: React.FC = () => {
  const { t, i18n } = useCustomTranslation()
  const currentLanguage = i18n.language
  const isAr = currentLanguage === 'ar'

  const isLoading = useSelector((state: RootState) => state.home.isLoading)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return isLoading ? (
    <Loader />
  ) : (
    <main>
      <Hero isAr={isAr} />
      <Quotation1 isAr={isAr} t={t} />
      <About isAr={isAr} t={t} />
      <Quotation2 isAr={isAr} t={t} />
      <LatestNews isAr={isAr} t={t} />
    </main>
  )
}

export default Home
